const wrapper = "_35swpjkvwc";
const container = "_35sc1j45yjs";

export { container, wrapper };
import "./organism.input-container.style.linaria.module.css";
//# sourceMappingURL=organism.input-container.style.js.map
